import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap, map } from 'rxjs';
import { AccountService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class LicenseNotExistGuard {
  router = inject(Router);
  private accountService = inject(AccountService);

  licenseExist(): Observable<boolean> {
    return this.accountService.licenseExist().pipe(
      map((resp: any) => {
        return resp ? false : true;
      })
    );
  }

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.licenseExist().pipe(
      tap((x: any) => {
        if (!x) {
          this.router.navigate(['/']);
        }
      })
    );
  }
}
